/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Skeleton } from 'antd';
import { CSSProperties, FC } from 'react';
import { searchPageSizeAtom } from 'packages/omnitag/state';
import { ResultsPagination } from 'packages/omnitag/results/results-pagination';
import { ResultsGrid, stylesGrid } from 'packages/omnitag/results/results-grid';
import { thumbnailContainerClass } from 'packages/omnitag/results/result-item';
import { useAtomValue } from 'jotai';
import styled from '@emotion/styled';
import { useRecoilValue } from 'recoil';
import { uiThemeAtom } from 'packages/at-shell/state/recoil/ui';
import { useTourRef } from 'packages/omnitag/hooks/use-tour-refs';
import { GridStatsPanel } from 'packages/omnitag/results/grid-stats-panel';

const styles: { [name: string]: CSSProperties } = {
  gridScroll: {
    padding: `1rem 0 0 1rem`,
    marginTop: '1em',
    overflowY: 'auto',
    flex: 1,
    display: 'flex',
  },
};

const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
`;

const GridContainer = styled.div<{
  isDark: boolean;
}>`
  background: ${({ isDark }): string => (isDark ? '#000000' : '#ffffff')};
  border: 1px solid ${({ isDark }): string => (isDark ? '#222222' : '#eeeeee')};
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const PaginationPanel = styled.div<{
  isDark: boolean;
}>`
  background: ${({ isDark }): string => (isDark ? '#000000' : '#ffffff')};
  border: 1px solid ${({ isDark }): string => (isDark ? '#222222' : '#eeeeee')};
  padding: 0.8rem;
  width: 100%;
  flex-shrink: 0;
`;

export const LoadingResults = (): JSX.Element => {
  const pageSize = useAtomValue(searchPageSizeAtom);
  const cells = [];
  for (let i = 0; i < pageSize; i++) {
    cells.push(<LoadingThumbnail key={i} />);
  }
  return <div style={stylesGrid.grid}>{cells}</div>;
};

export const LoadingThumbnail: FC = () => {
  return (
    <div className={thumbnailContainerClass}>
      <Skeleton.Image active />
    </div>
  );
};

export const ResultsLayout = (): JSX.Element => {
  const theme = useRecoilValue(uiThemeAtom);
  const resultsRef = useTourRef<HTMLDivElement>('results-grid');

  return (
    <LayoutWrapper>
      <GridContainer isDark={theme === 'dark'}>
        <div style={styles.gridScroll} ref={resultsRef}>
          <ResultsGrid />
        </div>
      </GridContainer>
      <GridStatsPanel />
      <PaginationPanel isDark={theme === 'dark'}>
        <ResultsPagination />
      </PaginationPanel>
    </LayoutWrapper>
  );
};
